import { render, staticRenderFns } from "./ChargeWay.vue?vue&type=template&id=4597c775&scoped=true&"
import script from "./ChargeWay.vue?vue&type=script&lang=js&"
export * from "./ChargeWay.vue?vue&type=script&lang=js&"
import style0 from "./ChargeWay.vue?vue&type=style&index=0&id=4597c775&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597c775",
  null
  
)

export default component.exports